
export default {
  init() {
    $(document).ready(function () {

      $('g.highlight').on('mouseenter', function () {
        $('nav ul li button').blur();
        $('.grey').removeClass('grey');
        $('g.highlight').not(this).addClass('grey');
        $('g.full-graphic').addClass('grey');
        $('.show').removeClass('show');
        if ($(window).outerWidth() >= 992) {
          $('.content-' + $(this).data('target')).addClass('show');
        }
      })

      $('g.full-graphic.grey').on('mouseleave', function () {
        $('g.full-graphic').removeClass('grey');
        $('g.highlight').removeClass('grey');
      });

      $('g.highlight').on('click', function () {
        if ($(window).outerWidth() < 992) {
          $('body').addClass('fixed');
          $('.content').addClass('show');
          $('.content-' + $(this).data('target')).addClass('show');
        }
      })

      $('.interactive-report').on('click', '.content.show', function () {
        if ($(window).outerWidth() < 992) {
          $('body').removeClass('fixed');
          $('.content').removeClass('show');
          $('.content div').removeClass('show');
        }
      })

      $(window).on('resize', function () {
        $('body').removeClass('fixed');
        $('.grey').removeClass('grey');
        $('.content').removeClass('show');
        $('.content div').removeClass('show');
        $('.content-default').addClass('show');
      })

      $('.interactive-report').on('click', '.content.show div', function (event) {
        event.stopPropagation();
      })

      $('#next-arrow').on('click', function () {
        $('.arrows path').attr('opacity', 1);
        $(this).find('path').attr('opacity', .2);
        $('#page1').removeClass('on-page');
        $('#page2').addClass('on-page');
      })

      $('#prev-arrow').on('click', function () {
        $('.arrows path').attr('opacity', 1);
        $(this).find('path').attr('opacity', .2);
        $('#page2').removeClass('on-page');
        $('#page1').addClass('on-page');
      })

      $('nav ul li button').on('click', function () {
        $('nav ul').find('.active').removeClass('active')
        $(this).addClass('active')
        $('.show').removeClass('show');
        $('.content-default').addClass('show');
        $('.content-' + $(this).data('target')).addClass('show');

        $('g.full-graphic').removeClass('grey');
        $('g.highlight').removeClass('grey');
        // $('g.highlight[data-target='+$(this).data('target')+']').removeClass('grey');

        $('.pages').removeClass('on-page').addClass('off-page');
        $('#page' + $(this).data('page')).removeClass('off-page').addClass('on-page');

      });
    })

  },
  finalize() {
    // JavaScript to be fired on pages that use the alternating section layout, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/prolarisInteractiveReport.js